import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { Severity } from '../../atoms/Severity/Severity';
import { MultiSelect, MultiSelectProps, SelectMode } from './multi-select';
import { useMemo, type JSX } from 'react';

import { useTranslation } from 'react-i18next';

type SeverityOption = {
  value: string;
  label: JSX.Element;
};

export const SeverityMultiSelect = ({
  icon,
  label,
  setValue,
  value,
  showUnknown,
  dataTestId,
  ...props
}: Omit<MultiSelectProps<SeverityOption>, 'options' | 'mode' | 'label'> &
  SelectMode & { label?: string; showUnknown?: boolean }) => {
  const { t } = useTranslation('designSystem');
  const options: SeverityOption[] = useMemo(() => {
    const baseOptions = [
      {
        value: 'CRITICAL',
        label: <Severity severityLevel="CRITICAL" />,
      },
      {
        value: 'HIGH',
        label: <Severity severityLevel="HIGH" />,
      },
      {
        value: 'MEDIUM',
        label: <Severity severityLevel="MEDIUM" />,
      },
      {
        value: 'LOW',
        label: <Severity severityLevel="LOW" />,
      },
    ];

    if (showUnknown) {
      return [
        ...baseOptions,
        {
          value: 'UNKNOWN',
          label: <Severity severityLevel="UNKNOWN" />,
        },
      ];
    }

    return baseOptions;
  }, [showUnknown]);
  return (
    <MultiSelect
      {...props}
      icon={icon || (ShieldExclamationIcon as React.FC<{ className?: string }>)}
      label={label || t('severity')}
      options={options}
      setValue={setValue as any}
      value={value as any}
      dataTestId={dataTestId}
    />
  );
};
